<template>
  <b-overlay :show="loading" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" v-if="companyId > 0">Company Edit</th>
              <th scope="col" v-else>Company Add</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Company" label-for="title">
              <b-form-input
                required
                id="title"
                type="text"
                v-model="companyValue.title"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col cols="12">
            <b-button
              v-if="companyId == null"
              type="submit"
              @click.prevent="formSubmitted"
              variant="primary"
              class="float-right"
            >
              Save
            </b-button>
            <b-button
              v-else
              type="submit"
              @click.prevent="formSubmitted"
              variant="primary"
              class="float-right"
            >
              Save Changes
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-overlay>
</template>
<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import AppColorPaletteVue from "@/@core/layouts/components/AppColorPalette.vue";

export default {
  components: {
    vSelect,
    ToastificationContent,
    AppColorPaletteVue,
  },

  setup() {
    const company_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(company_APP_STORE_MODULE_NAME))
      store.registerModule(company_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(company_APP_STORE_MODULE_NAME))
        store.unregisterModule(company_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      companyValue: {
        title: "",
      },

      loading: false,
      companyId: null,
    };
  },

  watch: {},

  mounted() {
    this.getCompanyById();
  },

  methods: {
    getCompanyById() {
      this.loading = true;

      if (router.currentRoute.params.id) {
        this.companyId = parseInt(router.currentRoute.params.id);

        store
          .dispatch("settings/getCompanyById", {
            id: router.currentRoute.params.id,
          })
          .then((res) => {
            this.companyValue = res.data;

            this.loading = false;
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        this.loading = false;
      }
    },

    formSubmitted() {
      this.loading = true;
      if (!this.companyValue.title) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "Please fill in all fields.",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.loading = false;
        return;
      }

      if (this.companyId == null) {
        store
          .dispatch("settings/saveCompany", this.companyValue)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Company Add Successful",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });

            router.push({ name: "settings-companies" });
          })
          .catch((error) => {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        store
          .dispatch("settings/updateCompany", this.companyValue)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Company Update Successful",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });

            router.push({ name: "settings-companies" });
          })
          .catch((error) => {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
